export default "__VITE_ASSET__BP1YOfr3__"